import { setConfig } from "@selkirk-systems/layout";

// export const MEDIA = {
//     PHONE: "(max-width: 425px)",
//     TABLET: "(min-width:426px) and (max-width: 768px)",
//     LAPTOP: "(min-width:769px) and (max-width:1024px)",
//     DESKTOP: "(min-width:1025px) and (max-width: 1440px)",
//     WIDE: "(min-width:1441px)",
// };

setConfig({
    breakpoints:{
        PHONE:"(max-width: 559px)",
        TABLET:"(min-width:560px) and (max-width: 768px)"
    }
})